import { NavList } from "../shared";

const abbvieConfigList = [
    { url: "/global-config/abbvie-id/app-list", name: "App Configuration" },
    { url: "/global-config/abbvie-id/icc-config", name: "ICC Configuration" },
    { url: "/global-config/abbvie-id/veeva-config", name: "Veeva Configuration" },
];

const AbbvieIDConfig = () => {
    return (
        <NavList
            backUrl="/global-config"
            title="AbbVie ID Configuration"
            navList={abbvieConfigList}
        />
    );
};

export default AbbvieIDConfig;
